import { render } from "./OCRComponent.vue?vue&type=template&id=bcdb9272&scoped=true"
import script from "./OCRComponent.vue?vue&type=script&lang=ts"
export * from "./OCRComponent.vue?vue&type=script&lang=ts"

import "./OCRComponent.vue?vue&type=style&index=0&id=bcdb9272&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bcdb9272"

export default script